import { Box, Text } from '@wix/design-system';
import { Faq as PlatformFaq } from '@wix/premium-purchase-platform/@components';
import React from 'react';
import { ECLIPSE_BG } from '../../utils/consts';
import { useCurrentModule } from '../ModuleProvider';
import { useFoldScrollBiEvent } from '../../hooks/useFoldScrollBiEvent';
import s from './Faq.scss';
const FAQ_FOLD_DATA_HOOK = 'faq-fold';
const FAQ_FOLD_NAME = 'faq';
export const Faq = _ref => {
  let {
    headerDirection,
    question,
    answer,
    mobile = false
  } = _ref;
  const module = useCurrentModule();
  const {
    t,
    Trans
  } = module.internals.useTranslations();
  const {
    utils
  } = PlatformFaq.useFaq({
    componentName: 'Faq'
  });
  useFoldScrollBiEvent({
    selector: `[data-hook="${FAQ_FOLD_DATA_HOOK}"]`,
    foldName: FAQ_FOLD_NAME,
    pageName: 'select-plan',
    deviceType: mobile ? 'mobile' : 'desktop'
  });
  const renderWithParams = content => utils.renderWithParams(Trans, t, content);
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: FAQ_FOLD_DATA_HOOK,
    borderRadius: "12px",
    background: ECLIPSE_BG,
    padding: mobile ? '30px' : '0 18px',
    boxSizing: "border-box",
    width: "100%",
    className: mobile ? s.faqMobileRoot : undefined
  }, /*#__PURE__*/React.createElement(PlatformFaq.Root, {
    background: "transparent",
    useLoader: true,
    onActionClick: event => {
      module.internals.bi.onFaqLinkClick == null || module.internals.bi.onFaqLinkClick({
        event
      });
    }
  }, _ref2 => {
    var _data$items, _data$title, _data$items2;
    let {
      data
    } = _ref2;
    const faqLastIndex = (((_data$items = data.items) == null ? void 0 : _data$items.length) ?? 0) - 1;
    return /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      width: "100%"
    }, /*#__PURE__*/React.createElement(Box, {
      direction: headerDirection ?? 'horizontal',
      align: "space-between",
      verticalAlign: "middle"
    }, /*#__PURE__*/React.createElement(PlatformFaq.Header, null, /*#__PURE__*/React.createElement(Text, {
      className: mobile ? `${s.title} ${s.mobileTitle}` : s.title
    }, t(((_data$title = data.title) == null ? void 0 : _data$title.translationKey) ?? ''))), /*#__PURE__*/React.createElement(PlatformFaq.Subtitle, null, mobile ? /*#__PURE__*/React.createElement("span", {
      className: s.mobileSubtitle
    }, renderWithParams(data.subtitle)) : renderWithParams(data.subtitle))), /*#__PURE__*/React.createElement(PlatformFaq.Content, null, (_data$items2 = data.items) == null ? void 0 : _data$items2.map((item, idx) => {
      var _item$question;
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: idx
      }, /*#__PURE__*/React.createElement(PlatformFaq.Item, {
        iconProps: {
          size: mobile ? 30 : 35,
          style: {
            marginTop: mobile ? '8.5px' : '6px'
          }
        },
        question: (question == null ? void 0 : question(item.question)) ?? t(((_item$question = item.question) == null ? void 0 : _item$question.translationKey) ?? ''),
        answer: (answer == null ? void 0 : answer(item.answer)) ?? renderWithParams(item.answer),
        onItemClick: _ref3 => {
          var _item$question2;
          let {
            action
          } = _ref3;
          module.internals.bi.onFaqItemClick == null || module.internals.bi.onFaqItemClick({
            action,
            questionKey: (_item$question2 = item.question) == null ? void 0 : _item$question2.translationKey
          });
        }
      }), idx < faqLastIndex && mobile && /*#__PURE__*/React.createElement(Box, {
        width: "100%",
        height: "1px",
        backgroundColor: "#0006241A"
      }));
    })));
  }));
};
//# sourceMappingURL=Faq.js.map